import  { useEffect, useState } from "react";
import Cookies from 'js-cookie';  
export async function accounuserdetails() { 
 const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL ; 
// localStorage.clear();
  const accountlogin = async (username:string,password:string) => { 
   const data = { emailid: username,password:password}; 
  
    try {
       const response = await fetch(`${API_BASE_URL}/Account/Account/Login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
       
      if (!response.ok) {
       const errText = await response.text(); // get backend message
        console.error("Login failed:", errText);
        if (errText.includes("not registered")) {
          if (errText.includes("not registered")) {
          alert(
            "⚠️ Access Notice\n\n" +
            "Your access to the application is currently unavailable because the registration process is incomplete.\n\n" +
            "📧 Please contact our support team:\n" +
            "👉 hello@dearcustomer.in\n\n" +
            "We’ll be happy to assist you "
          );
        }

        }    else
        alert(`Login failed:  ${errText}`);
        return null;
      }

      const logindata = await response.json();
      console.error("Login failed:", logindata);
    // Save token
     return logindata;
    } catch (err: any) {
        console.error("Login request error:", err);
        alert( err);
        return null;
    } finally {
      
    }
  };
   
return {
    accountlogin 
  };
}